import React from 'react';
import {openChat} from 'utils/crispActions';
import i18n from 'i18n';
import {Button, Input} from 'ui-library';

const DeleteOptions = (props) => (
  <div className='vf-row'>
  <div className='col-xs-10'>
    <div className='vf-font-big'>
      <h4>{i18n.get('INF_SETTINGS_ACCOUNT_DELETE_ACCOUNT_TITLE')}</h4>
      {i18n.get('INF_SETTINGS_ACCOUNT_DELETE_ACCOUNT_INTRO_MESSAGE')}{' '}
      <a onClick={openChat}>{i18n.get('INF_SETTINGS_ACCOUNT_DELETE_ACCOUNT_START_NEW_CONVERSATION_LINK_TEXT')}</a>
    </div>

    <h4 className='padding-top-2x'>{i18n.get('INF_SETTINGS_ACCOUNT_DELETE_ACCOUNT_DELETE_WARNING_TITLE')}</h4>

    {props.role === 'advertiser' ?
      <ul>
        <li>{i18n.get('ADV_SETTINGS_ACCOUNT_DELETE_DELETE_ADVERTISER_WARNING_POINT_TRANSACTIONS')}</li>
        <li>{i18n.get('ADV_SETTINGS_ACCOUNT_DELETE_DELETE_ADVERTISER_WARNING_POINT_CREDIT')}</li>
        <li>{i18n.get('ADV_SETTINGS_ACCOUNT_DELETE_DELETE_ADVERTISER_WARNING_POINT_INFLUENCERS')}</li>
        <li>{i18n.get('ADV_SETTINGS_ACCOUNT_DELETE_DELETE_ADVERTISER_WARNING_POINT_MISSYOU', {userName: props.userName})}.</li>
      </ul> :
      <ul>
        <li>
          {i18n.get('INF_SETTINGS_ACCOUNT_DELETE_ACCOUNT_DELETE_WARNING_POINT_PAYMENTS_PART_1')} {' '}({props.accountBalance}){' '}
          {i18n.get('INF_SETTINGS_ACCOUNT_DELETE_ACCOUNT_DELETE_WARNING_POINT_PAYMENTS_PART_2')}
        </li>
        <li>{i18n.get('INF_SETTINGS_ACCOUNT_DELETE_ACCOUNT_DELETE_WARNING_POINT_PERFORMANCE')}</li>
        <li>{i18n.get('INF_SETTINGS_ACCOUNT_DELETE_ACCOUNT_DELETE_WARNING_POINT_HISTORY')}</li>
        <li>{i18n.get('INF_SETTINGS_ACCOUNT_DELETE_ACCOUNT_DELETE_WARNING_POINT_SOCIAL_NETWORKS')}</li>
        <li>{i18n.get('INF_SETTINGS_ACCOUNT_DELETE_ACCOUNT_DELETE_WARNING_POINT_MISSYOU')} {props.userName}.</li>
      </ul>}

    <div className='margin-vertical-2x'><strong>{i18n.get('INF_SETTINGS_ACCOUNT_DELETE_ACCOUNT_TYPE_YOUR_PASSWORD')}</strong></div>

    <div className='padding-vertical-1x'>
      <Input type='password' placeholder={i18n.get('INF_SETTINGS_ACCOUNT_DELETE_PASSWORD_LABEL')} onChange={props.onPasswordChange} />
    </div>
    <div>
      <Button size='sm' color='default' onClick={props.onCancelDelete} onMouseEnter={props.onHoverCancel} onMouseLeave={props.onBlurCancel}>
        {i18n.get('INF_SETTINGS_ACCOUNT_DELETE_CANCEL_BUTTON_LABEL')}
      </Button>
      {' '}
      <Button size='sm' color='primary' onClick={props.onDeleteUser}>
        {i18n.get('INF_SETTINGS_ACCOUNT_DELETE_DELETE_BUTTON_LABEL')}
      </Button>
    </div>
  </div>
  <div className='col-xs-2'>
    {props.faceIcon}
  </div>
  </div>
);

export default DeleteOptions;
